/**
 * =============================================================================
 * geo-product-restrictions.js 
 * =============================================================================
 * Restrict product visibility to certain countries
 * =============================================================================
 */

var GeoProductRestrictions = {

  onReady: function(){
    // Only on product page
    if(!MP.Utilities.isProductPage()){
      return;
    }

    // Handle price restrictions
    if(document.querySelectorAll("[data-geo-restricted-price]").length > 0) {
      document.addEventListener('geodata:loaded', this.handleGeodataLoaded.bind(this, document.querySelector("[data-geo-restricted-price]"), "price"));
    }

    // Handle tag restrictions
    if(document.querySelectorAll("[data-geo-restricted-tag]").length > 0) {
      document.addEventListener('geodata:loaded', this.handleGeodataLoaded.bind(this, document.querySelector("[data-geo-restricted-tag]"), "tag"));
    }

    // Handle vendor restrictions
    if(document.querySelectorAll("[data-geo-restricted-vendor]").length > 0) {
      document.addEventListener('geodata:loaded', this.handleGeodataLoaded.bind(this, document.querySelector("[data-geo-restricted-vendor]"), "vendor"));
    }
  },

  handleGeodataLoaded: function(element, type, event) {
    let geodataJSON = event.detail.data;
    let isoCode = geodataJSON.country.iso_code;
    let rule = element.dataset.geoRestrictedRule;

    let countries = element.dataset[`geoRestricted${MP.Utilities.toTitleCase(type)}`].split(",");
    // console.log(`[G-P-R] Vendor ${rule}:`, countries);

    let isGeoRestricted = false;
    switch(rule){
      case "whitelist":
        isGeoRestricted = !countries.includes(isoCode);
        break;
      case "blacklist":
        isGeoRestricted = countries.includes(isoCode);
        break;
    }

    if(isGeoRestricted){
      // console.log(`[G-P-R] ${MP.Utilities.toTitleCase(type)} restricted - show messaging`);
      document.querySelectorAll(".geo-restricted").forEach(e => e.remove());
      document.querySelector(".geo-restriction-message").classList.remove("d-none");
    } else {
      // console.log(`[G-P-R] ${MP.Utilities.toTitleCase(type)} not restricted`);
    } 
  }
};

export default GeoProductRestrictions;